import React from "react";
import moment from "moment";
import {
  MdCalendarToday,
  MdRemoveRedEye,
  MdBookmark,
  MdBookmarkBorder,
  MdFavorite,
  MdFavoriteBorder,
} from "react-icons/md";
import { IoMdChatbubbles } from "react-icons/io";
import { useRecoilValue } from "recoil";
import { authAtom } from "@_recoil/_state";
import Link from "next/link";
import styles from "./news_short_info.module.scss";
import { getAssets } from "@unisearch/helpers";
import BookmarkAction from "@unisearch/common/ui_element/actions/bookmark";
import { isReadingListed } from "@unisearch/helpers";

/*
 Take props 
 data:{
  author: {
    name: "string",
    profileImage:{
      alt:'string',
      src: 'string",
    }
    publishDate: 'string',
    totalView: 'string',
    totalComment: 'string,
   }
 }
*/

export const NewsShortInfo = ({ data }) => {
  const profileInfo = useRecoilValue(authAtom);
  return (
    <div className={styles.info_wrapper}>
      <ul>
        {data?.author && (
          <li>
            <div className={styles.avatar}>
              <img
                src={
                  data?.author?.profileImage?.src ||
                  getAssets("assets/student-avatar-small.png")
                }
                alt="Author"
              />
            </div>
            <span>By {data?.author?.name}</span>
          </li>
        )}

        {data?.publishDate && (
          <li>
            <MdCalendarToday />
            <span>{moment(data?.publishDate).format("MMMM DD, YYYY")}</span>
          </li>
        )}

        {data?.totalComment && (
          <li>
            <IoMdChatbubbles />
            <span>{data?.totalComment}</span>
          </li>
        )}

        {data?.totalView && (
          <li>
            <MdRemoveRedEye />
            <span>{data?.totalView}</span>
          </li>
        )}

        <BookmarkAction
          customClasses={{
            btnClass: styles.btn_class,
          }}
          referance={"news"}
          referanceId={data?.id ? parseInt(data.id) : ""}
          is_bookmarked={isReadingListed(profileInfo, "news", data?.id)}
        />
      </ul>
    </div>
  );
};

export default NewsShortInfo;
